import { useEffect } from "react";

type PageMeta = {
  title: string;
  description: string;
  keywords?: string;
  path: string;
};

function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href: string) {
  let el = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function buildAbsoluteUrl(path: string) {
  const basePath = __BASE_PATH__.split("/").filter(Boolean).join("/");
  const prefix = basePath ? `/${basePath}` : "";
  const clean = path === "/" ? "" : path;
  return `${window.location.origin}${prefix}${clean}`;
}

export function usePageMeta({ title, description, keywords, path }: PageMeta) {
  useEffect(() => {
    const url = buildAbsoluteUrl(path);
    document.title = title;
    setMeta("name", "description", description);
    if (keywords) {
      setMeta("name", "keywords", keywords);
    }
    setMeta("name", "robots", "index,follow");
    setCanonical(url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "爆料直播");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
  }, [title, description, keywords, path]);
}